import { render, staticRenderFns } from "./NormalBanner.vue?vue&type=template&id=56004274&scoped=true"
import script from "./NormalBanner.vue?vue&type=script&lang=js"
export * from "./NormalBanner.vue?vue&type=script&lang=js"
import style0 from "./NormalBanner.vue?vue&type=style&index=0&id=56004274&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56004274",
  null
  
)

export default component.exports